import React from "react";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import ExportExcel from "../ExcelExport/ExcelExport";

const CommonGrid = ({
  data,
  dataState,
  style,
  onDataStateChange,
  columns,
  dynamicColumns = [],
  addButton,
  editButton,
  detailButton,
  deleteButton,
  extraToolbarButtons = [],
  exportExcelProps,
  dataItemKey,
  filterable = true,
  sortable = true,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <Grid
        data={data}
        dataItemKey={dataItemKey}
        {...dataState}
        onDataStateChange={onDataStateChange}
        sortable={sortable}
        resizable={true}
        filterable={filterable}
        style={style}
        pageable={{
          buttonCount: 3,
          pageSizes: [10, 20, 50, 100],
        }}
      >
        <GridToolbar>
          {addButton && (
            <Button color="primary" size="sm" onClick={addButton.onClick}>
              <i className="fa fa-plus-circle"></i> {addButton.text}
            </Button>
          )}
          {extraToolbarButtons.map((button) => (
            <Button
              color={button.color}
              type="button"
              size="sm"
              onClick={button.onClick}
            >
              <i className={button.icon}></i> {button.text}
            </Button>
          ))}
          {exportExcelProps && (
            <ExportExcel
              data={data}
              columns={columns}
              loadingFunction={exportExcelProps.loadingFunction}
              dataState={dataState}
              serviceMethod={exportExcelProps.serviceMethod}
              fileName={exportExcelProps.fileName}
            />
          )}
        </GridToolbar>
        {(detailButton || deleteButton || editButton) && (
          <GridColumn
            filterable={false}
            width={
              detailButton && deleteButton && editButton
                ? "300px"
                : detailButton && deleteButton
                ? "225px"
                : detailButton && editButton
                ? "225px"
                : deleteButton && editButton
                ? "225px"
                : detailButton
                ? "140px"
                : deleteButton
                ? "140px"
                : editButton
                ? "140px"
                : ""
            }
            cell={(props) => (
              <td>
                {editButton && (
                  <Button
                    color="info"
                    type="button"
                    size="sm"
                    style={{ marginRight: "5px" }}
                    onClick={() => editButton.onClick(props.dataItem)}
                  >
                    <i className="fa fa-pencil-square-o"></i> {editButton.text}
                  </Button>
                )}
                {detailButton && (
                  <Button
                    color="info"
                    type="button"
                    size="sm"
                    style={{ marginRight: "5px" }}
                    onClick={() => detailButton.onClick(props.dataItem)}
                  >
                    <i className="fa fa-info-circle"></i> {detailButton.text}
                  </Button>
                )}
                {deleteButton && (
                  <Button
                    color="danger"
                    type="button"
                    size="sm"
                    style={{ marginRight: "5px" }}
                    onClick={() => deleteButton.onClick(props.dataItem)}
                  >
                    <i className="fa fa-times-circle"></i> {deleteButton.text}
                  </Button>
                )}
              </td>
            )}
          />
        )}
        {columns.map((column) => (
          <GridColumn
            key={column.field}
            field={column.field}
            title={t(column.title_key)}
            width={column.width}
            cell={column.cell}
            filter={column.filter}
            filterCell={column.filterCell}
            filterable={column.filterable}
          />
        ))}
        {dynamicColumns.map((column) => (
          <GridColumn
            key={column}
            field={column}
            title={t(`additional_fields.${column}.text`)}
            filterable={false}
            width="200px"
          ></GridColumn>
        ))}
      </Grid>
    </div>
  );
};

export default CommonGrid;
